// COM-HUBS (2026-08-21): Propostas & Preços — Documentos + Composições + Custos.
// A ordem das abas segue a cadeia real do orçamento, de trás pra frente:
// custo unitário alimenta a composição, que alimenta a proposta.
import HubAbas, { HubTab } from '../../components/HubAbas';
import ComercialPropostas from '../ComercialPropostas';
import ComercialComposicoes from '../ComercialComposicoes';
import ComercialCustos from '../ComercialCustos';

const TABS: HubTab[] = [
  { key: 'documentos',  label: '📄 Documentos',      perm: 'comercial.documentos.propostas.ver', render: () => <ComercialPropostas /> },
  { key: 'composicoes', label: '🧮 Composições',     perm: 'comercial.composicoes.ver',          render: () => <ComercialComposicoes /> },
  { key: 'custos',      label: '💲 Custos Unitários', perm: 'comercial.custos_unitarios.ver',     render: () => <ComercialCustos /> },
];

export default function ComercialPropostasHub() {
  return <HubAbas tabs={TABS} />;
}
